import * as React from "react";
import {
    Typography, Box, Tooltip,
    alpha
} from "@mui/material";
import {
    DeleteOutline as DefaultIcon,
    Inventory2,
    Recycling,
    LocalShipping,
    Category,
    Warehouse
} from "@mui/icons-material";

const EQUIPMENT_VISUALS: Record<
  string,
  { icon: React.ReactElement; img: (size?: string) => string; label?: string }
> = {
  bac: {
    icon: <Inventory2 fontSize="small" />,
    img: (size) =>
      `/assets/equipments/bac${
        size ? `-${String(size).toLowerCase()}` : ""
      }.jpg`,
    label: "Bac",
  },
  benne: {
    icon: <Warehouse fontSize="small" />,
    img: () => `/assets/equipments/benne.jpg`,
    label: "Benne",
  },
  palette: {
    icon: <Category fontSize="small" />,
    img: () => `/assets/equipments/palette.jpg`,
    label: "Palette",
  },
  compacteur: {
    icon: <Recycling fontSize="small" />,
    img: () => `/assets/equipments/compacteur.jpg`,
    label: "Compacteur",
  },
  roll: {
    icon: <LocalShipping fontSize="small" />,
    img: () => `/assets/equipments/roll.jpg`,
    label: "Roll",
  },
};

export const EquipmentIconWithPreview: React.FC<{
  name: string;
  size?: string;
  labelText?: string;
}> = ({ name, size, labelText }) => {
  const key = String(name || "")
    .toLowerCase()
    .trim();
  const visual = EQUIPMENT_VISUALS[key];

  const icon = visual?.icon ?? <DefaultIcon fontSize="small" />;
  const imgSrc = visual?.img(size) ?? `/assets/equipments/default.jpg`;

  const title = labelText || visual?.label || name;

  return (
    <Tooltip
      title={
        <Box sx={{ p: 0.5 }}>
          <Typography
            variant="caption"
            fontWeight={600}
            sx={{ display: "block", mb: 0.5 }}
          >
            {title} {size ? `· ${size}` : ""}
          </Typography>
          <Box
            component="img"
            src={imgSrc}
            alt={title}
            sx={{
              display: "block",
              width: 220,
              height: "auto",
              objectFit: "cover",
              borderRadius: 1,
              border: "1px solid",
              borderColor: "divider",
              bgcolor: "background.paper",
            }}
            onError={(e: any) => {
              e.currentTarget.src = "/assets/equipments/default.jpg";
            }}
          />
        </Box>
      }
      arrow
      placement="top"
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: "background.paper",
            color: "text.primary",
            border: "1px solid",
            borderColor: "divider",
            boxShadow: (t) =>
              `0 6px 24px ${alpha(t.palette.common.black, 0.18)}`,
          },
        },
      }}
    >
      <Box
        sx={{
          width: 38,
          height: 38,
          borderRadius: 1,
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          color: "text.primary",
          border: "1px solid",
          borderColor: "divider",
        }}
      >
        {icon}
      </Box>
    </Tooltip>
  );
};
